/* original - assumed USD formatting
export default {
  // Format price to have 2 decimal places, prepend $, and add commas
  // NOTE: This function expects Shopify price format, so if shopifyPrice = 1000, then it will return $10
  formatPrice (shopifyPrice) {
    return `$${(parseInt(shopifyPrice) / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  }
}
*/

// Determine US vs UK - og and paypal currencies are the long way around to get this to work in dev environments
// not sure if paypal is always availale, og only available on PDPs
const language = document.documentElement.lang
let enLocale = 'en-US'
let enCurrency = 'USD'
const ogCurrency = document.querySelector('meta[property~="og:price:currency"][content]') ? document.querySelector('meta[property~="og:price:currency"][content]').content : ''
const paypalCurrency = document.getElementById('in-context-paypal-metadata') ? document.getElementById('in-context-paypal-metadata').dataset.currency.value : ''
if (window.location.host.includes('international') || paypalCurrency === 'GPB' || ogCurrency === 'GBP') {
  enLocale = 'en-GB'
  enCurrency = 'GBP'
}

const currencyDefaults = {
  en: enCurrency,
  de: 'EUR',
  es: 'EUR',
  fr: 'EUR',
  nl: 'EUR',
  sv: 'SEK'
}
const currency = currencyDefaults[language]

// not sure if es and fr are correct
const fullyQualifiedLocaleDefaults = {
  en: enLocale,
  de: 'de-DE',
  es: 'es-ES',
  fr: 'fr-FR',
  nl: 'nl-NL',
  sv: 'sv-SE'
}

export default {
  formatPrice (shopifyPrice) {
    // NOTE: This function expects Shopify price format, so if shopifyPrice = 1000, then it will return $10
    return new Intl.NumberFormat(fullyQualifiedLocaleDefaults[language], { style: 'currency', currency }).format(shopifyPrice / 100)
  }
}
